export const DEFAULT_DASHBOARD_QUERY_ARGS = {
    aggregation: "day",
    from: new Date(Date.now() + -14 * 24 * 3600 * 1000),
    to: new Date(),
    conditions: {
        relation: "AND",
        entries: [
            {
                field: "event_type",
                compare: "=",
                value: "pageview",
            }
        ],
    },
}